<template>
  <div class="form-progress-wrap edit-profile basic-info-wrap">
    <BaseLoading  opaque :spinning="athleteLoading">
      <div class="container">
        <div class="steps-content">
          <div class="general-form-wrap teams-played-info-wrap box-wrapper">
            <div class="teams-played-form-wrap">
              <div class="heading">
                <h2 class="form-title">TEAMS YOU'VE PLAYED FOR</h2>
              </div>
              <div class="team-detail-wrap">
                <div
                  class="team-detail"
                  v-for="(team, index) in teamList"
                  :key="`team-${index}`"
                >
                  <a-row :gutter="16">
                    <a-col :sm="24">
                      <a-input v-model="team.name" placeholder="Team Name" />
                    </a-col>
                    <a-col :sm="24">
                      <a-select
                        show-search
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        placeholder="Select Level"
                        v-model="team.level"
                      >
                        <a-select-option
                          v-for="(level, index) in levelList"
                          :key="`level=${index}`"
                          :value="level"
                          >{{ level }}</a-select-option
                        >
                      </a-select>
                    </a-col>
                    <a-col :sm="24">
                      <a-select
                        show-search
                        mode="multiple"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        placeholder="Select Position"
                        :value="team.positionIds"
                        @change="value => (team.positionIds = value)"
                      >
                        <a-select-option
                          v-for="(position, index) in positionList"
                          :key="`positions-${index}`"
                          :value="position._id"
                          >{{ position.name }}</a-select-option
                        >
                      </a-select>
                    </a-col>
                    <a-col :sm="24">
                      <a-input
                        v-model="team.coachName"
                        placeholder="Coach Name"
                      />
                    </a-col>
                    <a-col :sm="24">
                      <a-input
                        v-model="team.coachEmail"
                        placeholder="Coach's Email Address"
                      />
                    </a-col>
                    <a-col :sm="24">
                      <a-input
                        v-model="team.coachPhone"
                        placeholder="Coach's Phone Number"
                      />
                    </a-col>
                  </a-row>
                  <div class="button-wrap">
                    <span v-if="team._id === null">
                      <a-popconfirm
                        title="Sure you want to delete this video?"
                        @confirm="removeTeam(index)"
                        ok-text="Yes"
                        cancel-text="No"
                      >
                        <a-button type="danger" icon="delete">Delete</a-button>
                      </a-popconfirm>
                    </span>
                    <span v-else>
                      <a-popconfirm
                        title="Are you sure  you want to delete this team? It will be removed from your profile."
                        @confirm="deleteTeam(team)"
                        ok-text="Yes"
                        cancel-text="No"
                      >
                        <a-button type="danger" icon="delete">Delete</a-button>
                      </a-popconfirm>
                    </span>
                    <span v-if="team._id === null">
                      <a-button
                        type="primary"
                        icon="file-add"
                        class="save-button"
                        v-on:click="saveNewTeam(team)"
                        >Save</a-button
                      >
                    </span>
                    <span v-else>
                      <a-button
                        type="primary"
                        icon="file-add"
                        class="save-button"
                        v-on:click="editTeam(team)"
                        >Update</a-button
                      >
                    </span>
                  </div>
                </div>
                <div class="team-detail add-team-wrap" v-if="teamlength < 5">
                  <div class="team-content">
                    <a-row :gutter="16">
                      <a-col :sm="24">
                        <a-input placeholder="Team Name" />
                      </a-col>
                      <a-col :sm="24">
                        <a-select placeholder="Select Level">
                          <a-select-option
                            show-search
                            option-filter-prop="children"
                            :filter-option="filterOption"
                            v-for="(level, index) in levelList"
                            :key="index"
                            :value="level"
                            >{{ level }}</a-select-option
                          >
                        </a-select>
                      </a-col>
                      <a-col :sm="24">
                        <a-select
                          show-search
                          mode="multiple"
                          option-filter-prop="children"
                          :filter-option="filterOption"
                          placeholder="Select position"
                        >
                          <a-select-option
                            v-for="(position, index) in positionList"
                            :key="`position-${index}`"
                            :value="position._id"
                            >{{ position.name }}</a-select-option
                          >
                        </a-select>
                      </a-col>
                      <a-col :sm="24">
                        <a-input placeholder="Coach Name" />
                      </a-col>
                      <a-col :sm="24">
                        <a-input placeholder="Coach's Email Address" />
                      </a-col>
                      <a-col :sm="24">
                        <a-input placeholder="Coach's Phone Number" />
                      </a-col>
                    </a-row>
                    <div class="button-wrap">
                      <span>
                        <a-popconfirm
                          title="Sure you want to delete this video?"
                          ok-text="Yes"
                          cancel-text="No"
                        >
                          <a-button type="danger" icon="delete"
                            >Delete</a-button
                          >
                        </a-popconfirm>
                      </span>
                      <span>
                        <a-button type="primary" icon="file-add">Save</a-button>
                      </span>
                    </div>
                  </div>
                  <div class="add-new-button" v-on:click="addNewTeam">
                    <div class="text-detail">Add Another</div>
                    <a-icon
                      type="plus"
                      :style="{ fontSize: '44px', color: '#000' }"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseLoading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { RepositoryFactory } from "../../../../../repositories/RepositoryFactory";
const TaxonomyRepository = RepositoryFactory.get("taxonomy");
const athleteRepository = RepositoryFactory.get("athlete");
const STORE_KEY = "playerStore";
const ATHLETE_STORE_KEY = "athleteStore";

export default {
  name: "TeamsInfo",
  props: ["id"],
  data() {
    return {
      teamlength: 1,
      levelList: ["Collegiate","High School", "Club", "Recreation"],
      positionList: [],
      teamList: [
        {
          _id: null,
          name: "",
          level: [],
          position: [],
          coachName: "",
          email: "",
          coachPhone: "",
          positionIds: []
        }
      ]
    };
  },
  created() {
    this.dispatcher();
    TaxonomyRepository.getTaxonomyValues("Player Position").then(response => {
      this.positionList = response.data.taxonomy.values;
    });
  },
  computed: {
    ...mapGetters({
      ProfileData: `${STORE_KEY}/getViewProfileData`,
      athlete: `${ATHLETE_STORE_KEY}/athlete`,
      athleteLoading: `${ATHLETE_STORE_KEY}/athleteLoading`
    })
  },
  methods: {
    async dispatcher() {
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
        id: this.id
      });
    },
    ...mapActions({
      addPlayerTeams: `${STORE_KEY}/addPlayerTeams`
    }),
    addNewTeam() {
      if (this.teamlength < 5) {
        let newdata = {
          _id: null,
          name: "",
          level: [],
          position: [],
          coachName: "",
          email: "",
          coachPhone: "",
          positionIds: []
        };
        this.teamlength = this.teamlength + 1;
        this.teamList.push(newdata);
      }
    },
    editTeam(team) {
      let toSend = {
        name: team.name,
        level: team.level,
        position: team.positionIds,
        coachName: team.coachName,
        coachEmail: team.coachEmail,
        coachPhone: team.coachPhone,
        slug: "teamplayed"
      };
      if (Object.values(toSend).includes("")) {
        this.$notification.error({
          message: "Error",
          description: "Please enter all the values to save"
        });
        return;
      }
      athleteRepository
        .editPlayerTeams(toSend, team._id)
        .then(async response => {
          this.$message.success("Team updated successfully!");
          await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
            id: this.id
          });
        });
    },
    saveNewTeam(team) {
      let toSend = {
        atheleteMainProfileId: this.id,
        name: team.name,
        level: team.level,
        position: team.positionIds,
        coachName: team.coachName,
        coachEmail: team.coachEmail,
        coachPhone: team.coachPhone,
        slug: "teamplayed"
      };
      if (Object.values(toSend).includes("")) {
        this.$notification.error({
          message: "Error",
          description: "Please enter all the values to save"
        });
        return;
      }
      athleteRepository.postPlayerTeams(toSend).then(async response => {
        this.$message.success("New Team added successfully!");
        await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
          id: this.id
        });
      });
    },
    deleteTeam(team) {
      athleteRepository
        .deletePlayerTeams(team._id, { slug: "teamplayed" })
        .then(async response => {
          this.$message.success("Team deleted successfully!");
          TaxonomyRepository.getTaxonomyValues("Player Position").then(
            response => {
              this.positionList = response.data.taxonomy.values;
            }
          );
          await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
            id: this.id
          });
        });
    },
    removeTeam(index) {
      this.teamlength = this.teamlength - 1;
      this.teamList.splice(index, 1);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    }
  },
  watch: {
    athlete(newVal, _) {
      if (newVal.hasOwnProperty("teamPlayedData")) {
        if (newVal.teamPlayedData.length > 0) {
          this.teamList = newVal.teamPlayedData;
          this.teamList = this.teamList.map(item => ({
            ...item,
            positionIds: item.position.map(pos => pos._id)
          }));
          this.teamlength = newVal.teamPlayedData.length;
        }
      }
    }
  }
};
</script>
<style lang="scss"></style>
